module.exports = "<a id=\"<%= id %>\" class=\"creative--scrollable-mpu\"\n    href=\"<%=clickMacro%><%=destination%>\"\n    target=\"_new\">\n    <div class=\"creative--scrollable-mpu-inner\">\n    \t<%=backgroundImage%>\n    \t<div class=\"creative--scrollable-mpu-static-image\" style=\"background-image: url('<%=layer1Image%>');\"></div>\n    </div>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/scrollable-mpu-v2.html
// module id = 590
// module chunks = 1